"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _vk = _interopRequireDefault(require("./img/vk.svg"));

var _fb = _interopRequireDefault(require("./img/fb.svg"));

var _odnoklasnik = _interopRequireDefault(require("./img/odnoklasnik.svg"));

var _twitter = _interopRequireDefault(require("./img/twitter.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DEFAULT_SOCIALS = {
  vk: {
    img: _vk["default"],
    background: '#4C6F92',
    link: 'https://vk.com/domru'
  },
  fb: {
    img: _fb["default"],
    background: '#3f5c9a',
    link: 'https://www.facebook.com/dom.ru/'
  },
  tw: {
    img: _twitter["default"],
    background: '#1BA3E5',
    link: 'https://twitter.com/domru_'
  },
  odn: {
    img: _odnoklasnik["default"],
    background: '#EA7147',
    link: 'https://ok.ru/domru'
  }
};

var List = _styledComponents["default"].ul.withConfig({
  displayName: "social__List",
  componentId: "sc-1tv4vki-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    margin: 0;\n    width: 208px;\n    padding-left: 0;\n"])));

var Item = _styledComponents["default"].li.withConfig({
  displayName: "social__Item",
  componentId: "sc-1tv4vki-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    list-style: none;\n"])));

var Link = _styledComponents["default"].a.withConfig({
  displayName: "social__Link",
  componentId: "sc-1tv4vki-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 39px;\n    height: 39px;\n    background: ", ";\n    opacity: 0.75;\n    transition: 0.25s;\n    cursor: pointer;\n    border-radius: ", ";\n    &:hover {\n        opacity: 1;\n        transition: 0.25s;\n    }\n"])), function (props) {
  return props.bg || _constants.COLORS.grey;
}, function (props) {
  return props.borderRadius || '4px';
});

var IconImage = _styledComponents["default"].img.withConfig({
  displayName: "social__IconImage",
  componentId: "sc-1tv4vki-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-width: 25px;\n    max-height: 25px;\n"])));

var Social = /*#__PURE__*/function (_Component) {
  _inherits(Social, _Component);

  var _super = _createSuper(Social);

  function Social() {
    _classCallCheck(this, Social);

    return _super.apply(this, arguments);
  }

  _createClass(Social, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$socials = _this$props.socials,
          socials = _this$props$socials === void 0 ? DEFAULT_SOCIALS : _this$props$socials,
          radius = _this$props.radius,
          className = _this$props.className;
      var types = Object.keys(socials);
      var buttons = types.map(function (type) {
        return _objectSpread(_objectSpread({}, DEFAULT_SOCIALS[type]), socials[type]);
      });
      return /*#__PURE__*/_react["default"].createElement(List, {
        className: className
      }, buttons.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(Item, {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(Link, {
          href: item.click ? undefined : item.link,
          onClick: item.click,
          bg: item.background,
          borderRadius: radius,
          target: '_blank',
          rel: "noopener noreferrer".concat(item.link === 'https://vk.com/domru' ? ' nofollow' : ''),
          "aria-label": "social link"
        }, item.img && /*#__PURE__*/_react["default"].createElement(IconImage, {
          src: item.img,
          alt: "social icon"
        })));
      }));
    }
  }]);

  return Social;
}(_react.Component);

var _default = Social;
exports["default"] = _default;